import { t } from '@lingui/macro';

export const formValidationErrorTitle = (): string => t`Please fix invalid fields before submitting`;
export const nameHasSpecialCharactersError = (): string => (
  t`Key names may not contain colons, quotation marks, or periods`
);
export const nameNotChangedError = (): string => t`Please enter a different name`;
